import { inBiliApp, isSupport, biliBridge } from '@bilibili/js-bridge'
import jumpLogin from '@plat-components/utils2/_esm5/jumpLogin'
import QRCode from 'qrcode'
import BiliAjax from '@bilibili/bili-app-ajax'
import Vue from 'vue'
import { objectToHump } from '../../public'

export const goToPopLogin = cb => {
  const loginUrl = `https://passport.bilibili.com/login?gourl=${encodeURIComponent(window.location.href)}`
  if (inBiliApp) {
    isSupport('auth.login').then(support => {
      if (support) {
        biliBridge.callNative({
          method: 'auth.login',
          data: {
            type: 'default',
          },
          onLogin(data) {
            if (data.state === 1) {
              cb && cb()
              window.location.reload()
            }
          },
        })
      } else {
        window.location.href = loginUrl
      }
    })
  } else {
    jumpLogin().then(() => {
      window.location.reload(true)
    })
  }
}

export function qrcodeUrl(url) {
  return new Promise((res, rej) => {
    const canvas = document.createElement('canvas')
    QRCode.toCanvas(
        canvas,
        url || window.location.href,
        {
          color: {
            dark: '#45a08f',
          },
        },
        function(error, url) {
          if (error) {
            rej(error)
          }
          res(url.toDataURL('image/png'))
          canvas.remove()
        },
    )
  })
}

const inServer = typeof window === undefined
const http = new BiliAjax({
  useCookie: true,
})
export default function({ url, data, method = 'get', errorToast = true, trans = true, transData = true, ...config }) {
  const prefix = ''
  let usePath = url
  if (usePath.includes('//')) {
    usePath = url
  } else {
    usePath = `${inServer ? 'http' : window.location.protocol}//${prefix}api.bilibili.com${usePath}`
  }
  return http[method](usePath, data, config)
    .then(res => {
      if (trans) {
        if (res.code === 0) {
          const { data } = res
          if (transData) {
            return objectToHump(data)
          } else {
            return data
          }
        } else if (errorToast) {
          Vue.prototype.$toast && Vue.prototype.$toast.info(res.message || '网络错误请稍后重试')
          return Promise.reject(res)
        }
      } else {
        return objectToHump(res)
      }
    })
    .catch(err => {
      if (errorToast) {
        Vue.prototype.$toast && Vue.prototype.$toast.info(err.message || '网络错误请稍后重试')
      }
      return Promise.reject(err)
    })
}
